import { useConfig } from '../ConfigProvider';
import Countdown from './Countdown';

export default function PromoBanner({club}) {
    const config = useConfig(); // could use config?.defaultOfferUrl to display offer on the club selection page one day
    const url = club?.currentOffer?.url;
    const expirationDate = club?.currentOffer?.expirationDate;

    if (config.plans?.withBanner && url) {
        return <>
            <div className='promo-banner w-full justify-center items-center' style={{ display: "flex", justifyContent: 'center' }}>
                <img alt="Bannière" src={url} style={{ height: 'auto' }} className="w-full lg:w-[60%]" />
            </div>
            {expirationDate && <Countdown targetDate={expirationDate} />}
        </>
    }

    return null;
}
